import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { AnchorSectionKey } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/hooks/anchor';
import type { ReportInferencesMismatchViewData } from '@/hooks/report_inferences/useReportInferencesMismatchCaptions';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { ApplicationDetail } from './ApplicationDetail';

type ApplicationContentProps = {
  reportId: string;
  paymentTotalAmount?: string | null;
  onMismatchViewDataChange?: Dispatch<
    SetStateAction<ReportInferencesMismatchViewData | undefined>
  >;
};

export const ApplicationContent: FC<ApplicationContentProps> = memo(
  ({ reportId, paymentTotalAmount, onMismatchViewDataChange }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading
        id={AnchorSectionKey.APPLICATION_CONTENT}
        title={t('application_content.section_title')}
      >
        <ApplicationDetail
          reportId={reportId}
          paymentTotalAmount={paymentTotalAmount}
          onMismatchViewDataChange={onMismatchViewDataChange}
        />
      </SectionHeading>
    );
  }
);
ApplicationContent.displayName = 'ApplicationContent';
